export const handleDownload = async (fileUrl) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileUrl;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

export const base64ToFile = (base64, filename) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export function slugify(text = "") {
  return text
    .toString()
    .toLowerCase()
    .trim()

    // Replace accented characters (é → e, etc.)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")

    // Remove invalid chars
    .replace(/[^a-z0-9\s-]/g, "")

    // Replace spaces with -
    .replace(/\s+/g, "-")

    // Remove multiple -
    .replace(/-+/g, "-")

    // Trim - from start/end
    .replace(/^-+|-+$/g, "");
  }